// components/FormPDFTemplate.jsx
import React, { forwardRef } from "react";

const FormPDFTemplate = forwardRef(({ data, personalDetails, kycDetails, qualifications, workExperiences }, ref) => {
  const [profilePhoto, setProfilePhoto] = useState(null);

    // Fetch ONLY profile photo from API
    useEffect(() => {
      const fetchProfilePhoto = async () => {
        try {
          const res = await GetMyProfileService();

          // support both base64 and URL
          if (res?.profilePhoto) {
            setProfilePhoto(res.profilePhoto);
          }
        } catch (err) {
          // silently fail – PDF must still render
          console.error("Profile photo fetch failed");
        }
      };

      fetchProfilePhoto();
    }, []);

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

  return (
    <div
      ref={ref}
      style={{
        fontFamily: "'Helvetica', 'Arial', sans-serif",
        color: "#333",
        padding: "40px",
        fontSize: "12px",
        lineHeight: "1.4",
        backgroundColor: "white",
      }}
    >
      {/* Header */}
       <div style={{ borderBottom: "2px solid #4CAF50", paddingBottom: "15px", marginBottom: "30px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            
            {/* Title */}
            <div style={{ textAlign: "center", flex: 1 }}>
              <div style={{ fontSize: "16px", fontWeight: "600", color: "#2c3e50" }}>
                EMPLOYEE ONBOARDING FORM
              </div>
              <div style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                Generated on: {formatDate(new Date().toISOString())}
              </div>
            </div>

            {/* Profile Photo */}
            <div
              style={{
                width: "90px",
                height: "110px",
                border: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                marginLeft: "20px",
              }}
            >
              {profilePhoto ? (
                <img
                  src={profilePhoto}
                  alt="Profile"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <span style={{ fontSize: "10px", color: "#999" }}>No Photo</span>
              )}
            </div>
          </div>
        </div>

      {/* Personal Information */}
        <div style={{ marginTop: "25px", paddingBottom: "8px", borderBottom: "2px solid #4CAF50" }}>
          <h3 style={{ color: "#2c3e50", fontSize: "13px", textTransform: "uppercase", margin: "0" }}>
            Personal Information
          </h3>
        </div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
        <tbody>
          <tr>
            <td style={{ padding: "8px 10px", width: "25%", fontWeight: "500", color: "#555" }}>Full Name</td>
            <td style={{ padding: "8px 10px" }}>
              {personalDetails.firstName} {personalDetails.middleName} {personalDetails.lastName}
            </td>
            <td style={{ padding: "8px 10px", width: "25%", fontWeight: "500", color: "#555" }}>Date of Birth</td>
            <td style={{ padding: "8px 10px" }}>{formatDate(personalDetails.dob)}</td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Gender</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.gender?.toUpperCase() || "N/A"}</td>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Blood Group</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.bloodGroup || "N/A"}</td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Mobile</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.phone}</td>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Email</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.email}</td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Father's Name</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.fatherName}</td>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Mother's Name</td>
            <td style={{ padding: "8px 10px" }}>{personalDetails.motherName}</td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Permanent Address</td>
            <td style={{ padding: "8px 10px", colSpan: "3" }}>{personalDetails.permanentAddress}</td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Residential Address</td>
            <td style={{ padding: "8px 10px", colSpan: "3" }}>{personalDetails.residentialAddress}</td>
          </tr>
        </tbody>
      </table>

      {/* KYC Details */}
      <div style={{ marginTop: "25px", paddingBottom: "8px", borderBottom: "2px solid #4CAF50" }}>
        <h3 style={{ color: "#2c3e50", fontSize: "13px", textTransform: "uppercase", margin: "0" }}>
          KYC & Banking Details
        </h3>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
        <tbody>
          <tr>
            <td style={{ padding: "8px 10px", width: "25%", fontWeight: "500", color: "#555" }}>Aadhaar Number</td>
            <td style={{ padding: "8px 10px", fontFamily: "'Courier New', monospace" }}>
              {kycDetails.aadhaarNumber || "Not Provided"}
            </td>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>PAN Number</td>
            <td style={{ padding: "8px 10px", fontFamily: "'Courier New', monospace" }}>
              {kycDetails.panNumber || "Not Provided"}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Bank Account</td>
            <td style={{ padding: "8px 10px", fontFamily: "'Courier New', monospace" }}>
              {kycDetails.bankAccount || "Not Provided"}
            </td>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>IFSC Code</td>
            <td style={{ padding: "8px 10px", fontFamily: "'Courier New', monospace" }}>
              {kycDetails.ifscCode || "Not Provided"}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px 10px", fontWeight: "500", color: "#555" }}>Bank Name</td>
            <td style={{ padding: "8px 10px", colSpan: "3" }}>{kycDetails.bankName || "Not Provided"}</td>
          </tr>
        </tbody>
      </table>

      {/* Education */}
      <div style={{ marginTop: "25px", paddingBottom: "8px", borderBottom: "2px solid #4CAF50" }}>
        <h3 style={{ color: "#2c3e50", fontSize: "13px", textTransform: "uppercase", margin: "0" }}>
          Education
        </h3>
      </div>
      {qualifications.length > 0 ? (
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
          <thead>
            <tr style={{ background: "#f8f9fa" }}>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Degree
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Institution
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Year
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Percentage
              </th>
            </tr>
          </thead>
          <tbody>
            {qualifications.map((edu, idx) => (
              <tr key={idx}>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{edu.degree}</td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{edu.schoolName}</td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{edu.year}</td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{edu.percentage}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div style={{ color: "#999", padding: "10px", textAlign: "center" }}>
          No education records
        </div>
      )}

      {/* Work Experience */}
      <div style={{ marginTop: "25px", paddingBottom: "8px", borderBottom: "2px solid #4CAF50" }}>
        <h3 style={{ color: "#2c3e50", fontSize: "13px", textTransform: "uppercase", margin: "0" }}>
          Work Experience
        </h3>
      </div>
      {workExperiences.length > 0 ? (
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
          <thead>
            <tr style={{ background: "#f8f9fa" }}>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Company
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Designation
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Duration
              </th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "500", borderBottom: "1px solid #e0e0e0" }}>
                Last Salary
              </th>
            </tr>
          </thead>
          <tbody>
            {workExperiences.map((work, idx) => (
              <tr key={idx}>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{work.company}</td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>{work.designation}</td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>
                  {formatDate(work.fromDate)} - {formatDate(work.toDate)}
                </td>
                <td style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>
                  {work.lastSalary ? `₹${work.lastSalary}` : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div style={{ color: "#999", padding: "10px", textAlign: "center" }}>
          No work experience records
        </div>
      )}

      

      {/* Footer */}
      <div style={{ marginTop: "30px", textAlign: "center", fontSize: "10px", color: "#999", paddingTop: "10px", borderTop: "1px solid #4CAF50" }}>
        Generated on {formatDate(new Date().toISOString())} | Onboarding Form
      </div>
    </div>
  );
});

FormPDFTemplate.displayName = "FormPDFTemplate";
export default FormPDFTemplate;
